import { render, staticRenderFns } from "./AddDepart.vue?vue&type=template&id=9976cd18&scoped=true&"
import script from "./AddDepart.vue?vue&type=script&lang=js&"
export * from "./AddDepart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9976cd18",
  null
  
)

export default component.exports